import { render, staticRenderFns } from "./_base-hero.vue?vue&type=template&id=bbb22e9e"
import script from "./_base-hero.vue?vue&type=script&lang=js"
export * from "./_base-hero.vue?vue&type=script&lang=js"
import style0 from "./_base-hero.vue?vue&type=style&index=0&id=bbb22e9e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports